module.exports = __webpack_public_path__ + "static/media/get-wasabi.57527d15.gif";